/* istanbul ignore file */
import axios from "axios";
import { API } from "../../const";
import { normParam } from "../../tools";
const M_API = API + "/api";
const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line
    get({}, { params }) {
      return axios
        .get(`${M_API}/dokumen${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },

    // eslint-disable-next-line
    statistikPusat(_, {}) {
      // return axios.get(`${API}/api/dokumen_pie_pusat`).then(res => {
      //   return res.data;
      // });
    },
    // eslint-disable-next-line
    rekapPusat(_, { params }) {
      return axios.get(`${API}/api/dokumen_rekap_pusat${normParam(params)}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    statistikPropinsi(_, { params }) {
      // return axios.get(`${API}/api/dokumen_pie_propinsi${normParam(params)}`).then(res => {
      //   return res.data;
      // });
    },
    // eslint-disable-next-line
    rekapPropinsi(_, { params }) {
      return axios.get(`${API}/api/dokumen_rekap_propinsi${normParam(params)}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    statistikKota(_, { params }) {
      // return axios.get(`${API}/api/dokumen_pie_kota${normParam(params)}`).then(res => {
      //   return res.data;
      // });
    },
    // eslint-disable-next-line
    rekapKota(_, { params }) {
      return axios.get(`${API}/api/dokumen_rekap_kota${normParam(params)}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    statistikKecamatan(_, { params }) {
      // return axios.get(`${API}/api/dokumen_pie_kecamatan${normParam(params)}`).then(res => {
      //   return res.data;
      // });
    },
    // eslint-disable-next-line
    rekapKecamatan(_, { params }) {
      return axios.get(`${API}/api/dokumen_rekap_kecamatan${normParam(params)}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    rekapKelurahan(_, { params }) {
      return axios.get(`${API}/api/dokumen_rekap_kelurahan${normParam(params)}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    keteranganPropinsi(_, id) {
      if (id) {
        return axios.get(`${API}/api/propinsi/${id}`).then(res => {
          return res.data;
        });
      }
    },
    // eslint-disable-next-line
    keteranganKota(_, id) {
      return axios.get(`${API}/api/kota/${id}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    keteranganKecamatan(_, id) {
      return axios.get(`${API}/api/kecamatan/${id}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    download({ state, getters, rootState, rootGetters }, { params }) {
      var url = `${API}/api/dokumen_rekap_pusat${normParam(params)}`;
      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    downloadRekapPropinsi({ state, getters, rootState, rootGetters }, { params }) {
      console.log("called");
      var url = `${API}/api/dokumen_rekap_propinsi${normParam(params)}`;
      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    downloadRekapKota({ state, getters, rootState, rootGetters }, { params }) {
      var url = `${API}/api/dokumen_rekap_kota${normParam(params)}`;
      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    downloadRekapKotaSK({ state, getters, rootState, rootGetters }, { params }) {
      return axios
        .get(`${API}/api/dokumen_kota_zip${normParam(params)}`)
        .then(res => {
          window.open(res.data.url_zip, "_blank");
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    downloadRekapKecamatan({ state, getters, rootState, rootGetters }, { params }) {
      var url = `${API}/api/dokumen_rekap_kecamatan${normParam(params)}`;
      window.open(url, "_blank");
    },
    // eslint-disable-next-line
    pengurusRekapKota({}, { params }) {
      var url = `${API}/api/jabatan_rekap_kota${normParam(params)}`;

      window.open(url, "_blank");
    },
    form(_, obj) {
      let formData = new FormData();
      formData.append("dokumen_id", obj.id);
      formData.append("dokumen", obj.file);
      formData.append("wilayah_id", obj.wilayah_id);
      formData.append("tingkat", obj.tingkat);

      return axios.post(`${M_API}/dokumen`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    },
    // eslint-disable-next-line
    drop(_, item) {
      return axios.delete(`${M_API}/dokumen/${item.id}`).then(res => {
        return res.data;
      });
    },

    // eslint-disable-next-line
    pengurusRekapKecamatan({}, { params }) {
      var url = `${API}/api/jabatan_rekap_kecamatan${normParam(params)}`;

      window.open(url, "_blank");
    }
  }
};

export default store;
